class SyllablesCartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const lineItemIndex = this.dataset.index;
      const cartDrawerElement = this.closest('cart-drawer');

      const itemInnerContainer = this.closest('div.header__cartMenu-itemInnerContainer');
      let itemQuantityInputElement;
      let cartLineItemVariantId;

      if (itemInnerContainer) {
        itemQuantityInputElement = itemInnerContainer.querySelector('input');
      }

      if (itemQuantityInputElement) {
        cartLineItemVariantId = itemQuantityInputElement.dataset.variantId;
      }

      const finallyCallback = () => {
        const productPageQuantityInput = document.getElementById("ProductVisualQuantity");
        let productPageVariantId;

        if (productPageQuantityInput) {
          productPageVariantId = productPageQuantityInput.dataset.variantId;
        }

        const itemInnerContainer = this.closest('div.header__cartMenu-itemInnerContainer');
        let itemQuantityInputElement;
        let cartLineItemVariantId;

        if (itemInnerContainer) {
          itemQuantityInputElement = itemInnerContainer.querySelector('input');
        }

        if (itemQuantityInputElement) {
          cartLineItemVariantId = itemQuantityInputElement.dataset.variantId;
        }

        const productDetailsOrderButton = document.getElementById("ProductDetailsOrderButton");

        if (
          productPageQuantityInput &&
          productPageVariantId &&
          itemQuantityInputElement &&
          cartLineItemVariantId &&
          cartLineItemVariantId === productPageVariantId &&
          productDetailsOrderButton &&
          productDetailsOrderButton.dataset.isProductAvailable === 'true'
        ) {
          productPageQuantityInput.dataset.quantityInCart = '0';
          productDetailsOrderButton.classList.remove('disabledButton');
          document.getElementById('ProductDetailsInfoMessage').classList.remove('displayBlockImportant');
          productDetailsOrderButton.dataset.isProductAbleToCart = 'true';
          productPageQuantityInput.value = 1;
        }
      };

      const callbackBeforeSetButtonsClickable = () => {
        const itemsListSectionsCollection = document.querySelectorAll('div.itemsList');

        itemsListSectionsCollection.forEach((itemsListSection) => {
          const formsCollection = itemsListSection.querySelectorAll('form');

          formsCollection.forEach((form) => {
            // find added product form on "Items list" section
            if (cartLineItemVariantId === form.dataset.variantId) {
              if (form.dataset.quantityInCart) {
                form.removeAttribute('data-quantity-in-cart');
              }
            }
          })
        })
      }

      const quantityToUpdate = 0;

      cartDrawerElement.updateQuantity(
        lineItemIndex,
        quantityToUpdate,
        true,
        finallyCallback,
        cartLineItemVariantId,
        callbackBeforeSetButtonsClickable
      );
    });
  }
}

customElements.define('syllables-cart-remove-button', SyllablesCartRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    const debounceOnChange = syllablesDebounce((event) => {
      const callbackBeforeSetButtonsClickable = () => {
        const itemsListSectionsCollection = document.querySelectorAll('div.itemsList');

        itemsListSectionsCollection.forEach((itemsListSection) => {
          const formsCollection = itemsListSection.querySelectorAll('form');

          formsCollection.forEach((form) => {
            // find added product form on "Items list" section
            if (Number(event.detail.variantId) === Number(form.dataset.variantId)) {
              // update data attribute "quantityInCart"
              if (form.dataset.quantityInCart) {
                form.dataset.quantityInCart = event.detail.quantity;
              }
            }
          })
        })
      }

      this.updateQuantity(
        event.detail.line,
        event.detail.quantity,
        event.detail.shouldCartBeOpened,
        event.detail.finallyCallback,
        event.detail.variantId,
        callbackBeforeSetButtonsClickable
      );
    }, debounceTimeout);

    this.addEventListener('update-quantity', debounceOnChange.bind(this));
  }

  connectedCallback() {
    this.updateCartItemsQuantityContainerVisibility();
    this.updateCartItemsAlignment();
    this.updateCartFreeShippingLine();

    const cartDrawerElement = this.closest('cart-drawer');

    document.addEventListener('add_product_to_cart', (event) => {
      cartDrawerElement.addItemToCart(event.detail.variantId, event.detail.quantity, event.detail.shouldCartBeOpened);
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: document.getElementById('CartDrawer').dataset.id,
        selector: 'cart-drawer'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  updateQuantity(
    line,
    quantity,
    shouldCartBeOpened,
    finallyCallback,
    variantId,
    callbackBeforeSetButtonsClickable
  ) {
    this.setButtonsClickable(false);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }, credentials: 'include' })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          return;
        }

        this.updateCartItemsQuantityValueOnCartIcon(parsedState.item_count);
        this.updateCartItemsQuantityContainerVisibility();

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          const updatedCartElement = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          elementToReplace.innerHTML = updatedCartElement.innerHTML;

          if (shouldCartBeOpened) {
            const cartButton = document.getElementById('CartButton');
            cartButton.click();
          }
        });

        const productDetailsQuantityInput = document.getElementById('ProductVisualQuantity');
        const productDetailsOrderButton = document.getElementById("ProductDetailsOrderButton");

        let productQuantityAfterQuantityChange;
        let changedProductVariantId;

        const cartResponse = await fetch('/cart.json', { credentials: 'include' });
        const updatedCartObject = await cartResponse.json();

        updatedCartObject.items.forEach((item) => {
          if (item.variant_id === Number(variantId)) {
            productQuantityAfterQuantityChange = item.quantity;
            changedProductVariantId = item.variant_id;
          }
        })

        // update current product quantity from cart for input in "Product details" section
        if (
          productDetailsQuantityInput &&
          productDetailsOrderButton &&
          changedProductVariantId === Number(productDetailsQuantityInput.dataset.variantId)
        ) {
          productDetailsQuantityInput.dataset.quantityInCart = productQuantityAfterQuantityChange;
          productDetailsOrderButton.dataset.isProductAbleToCart = 'true';
        }

        if (callbackBeforeSetButtonsClickable) {
          callbackBeforeSetButtonsClickable();
        }

        this.setButtonsClickable(true);
        this.updateCartItemsAlignment();
        this.updateCartFreeShippingLine();

        if (finallyCallback) {
          finallyCallback();
        }
      })
      .catch(() => {
        this.setButtonsClickable(true);
      })
  }

  addItemToCart(variantId, quantity, shouldCartBeOpened) {
    this.setButtonsClickable(false);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        quantity,
        id: variantId,
        sections: 'syllables-cart',
        sections_url: window.location.pathname
      }),
      credentials: 'include'
    })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          return;
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          const updatedCartElement = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          elementToReplace.innerHTML = updatedCartElement.innerHTML;

          if (shouldCartBeOpened) {
            document.getElementById('CartButton').click();
          }
        });

        const cartResponse = await fetch('/cart.json', { credentials: 'include' });
        const updatedCartObject = await cartResponse.json();

        this.updateCartItemsQuantityValueOnCartIcon(updatedCartObject.item_count);

        const productDetailsOrderButton = document.getElementById("ProductDetailsOrderButton");
        const productDetailsInfoMessage = document.getElementById("ProductDetailsInfoMessage");
        const productDetailsSectionElement = document.getElementById("ProductDetails");
        let productInventoryQuantity;

        if (productDetailsSectionElement) {
          productInventoryQuantity = Number(document.getElementById("ProductDetails").dataset.inventoryQuantity);
        }

        const productDetailsQuantityInput = document.getElementById('ProductVisualQuantity');
        const productPageQuantityInput = document.getElementById("ProductVisualQuantity");
        let productPageVariantId;

        if (productPageQuantityInput) {
          productPageVariantId = Number(productPageQuantityInput.dataset.variantId);
        }

        let productQuantityAfterQuantityChange;
        let addedProductVariantId;

        updatedCartObject.items.forEach((item) => {
          if (item.variant_id === Number(variantId)) {
            productQuantityAfterQuantityChange = item.quantity;
            addedProductVariantId = item.variant_id;
          }
        })

        if (
          !!productDetailsOrderButton &&
          !!productQuantityAfterQuantityChange &&
          !!productDetailsSectionElement &&
          productQuantityAfterQuantityChange >= productInventoryQuantity &&
          Number(variantId) === productPageVariantId
        ) {
          productDetailsInfoMessage.classList.add('displayBlockImportant');
          productDetailsOrderButton.classList.add('disabledButton');

          if (productDetailsOrderButton.dataset.isProductAvailable === 'true') {
            productDetailsOrderButton.dataset.isProductAbleToCart = 'false';
          }
        }

        // update current product quantity from cart for input in "Product details" section
        if (productDetailsQuantityInput && addedProductVariantId === productPageVariantId) {
          productDetailsQuantityInput.dataset.quantityInCart = productQuantityAfterQuantityChange;
          productDetailsQuantityInput.value = 1;
        }

        const itemsListSectionsCollection = document.querySelectorAll('div.itemsList');

        itemsListSectionsCollection.forEach((itemsListSection) => {
          const formsCollection = itemsListSection.querySelectorAll('form');

          formsCollection.forEach((form) => {
            // find added product form on "Items list" section
            if (addedProductVariantId === Number(form.dataset.variantId)) {
              form.dataset.quantityInCart = String(productQuantityAfterQuantityChange);
            }
          })
        })

        this.updateCartItemsQuantityContainerVisibility();
        this.updateCartItemsAlignment();
        this.updateCartFreeShippingLine();
        this.setButtonsClickable(true);
      })
      .catch(() => {
        this.setButtonsClickable(true);
      });
  }

  updateCartItemsQuantityContainerVisibility() {
    const isCartNotEmptyCondition = Number(document.getElementById('CartButtonQuantity').innerHTML) !== 0;
    const hasCartClassCondition = document.getElementById('CartButtonQuantityContainer').classList.contains('displayBlockImportant');

    if (isCartNotEmptyCondition) {
      if (!hasCartClassCondition) {
        document.getElementById('CartButtonQuantityContainer').classList.add('displayBlockImportant');
      }
    } else if (hasCartClassCondition) {
      document.getElementById('CartButtonQuantityContainer').classList.remove('displayBlockImportant');
    }
  }

  setButtonsClickable(isCartMenuAndBuyButtonsClickable) {
    const cartMenuElement = document.getElementById('CartMenu');
    const cartMenuCheckoutButtonElement = document.getElementById('CheckoutButton');
    const availableItemsListDesktopButtons = document.querySelectorAll(`button.itemsList__itemButtonDesktop[data-is-available="true"]`);
    const availableItemsListMobileButtons = document.querySelectorAll('button.itemsList__itemButtonMobile[data-is-available="true"]');
    const availableProductDetailsOrderButton = document.querySelector('button.productDetails__cartOrderButton[data-is-product-available="true"][data-is-product-able-to-cart="true"]');

    if (isCartMenuAndBuyButtonsClickable) {
      if (cartMenuElement) {
        cartMenuElement.classList.remove('disabledInteractivity');
      }
      if (cartMenuCheckoutButtonElement) {
        cartMenuCheckoutButtonElement.classList.remove('disabledButton');
      }

      if (availableProductDetailsOrderButton) {
        availableProductDetailsOrderButton.classList.remove('disabledButton');
      }
      if (availableItemsListDesktopButtons.length > 0) {
        availableItemsListDesktopButtons.forEach((itemsListDesktopButton) => {
          const formElement = itemsListDesktopButton.closest('form');

          const disablingClassRemoveCondition = formElement &&
            Number(formElement.dataset.quantityInCart) < Number(formElement.dataset.max) ||
            formElement && !formElement.dataset.quantityInCart && formElement.dataset.isProductAvailable === 'true';

          if (disablingClassRemoveCondition) {
            itemsListDesktopButton.classList.remove('disabledButton');
          }
        });
      }
      if (availableItemsListMobileButtons.length > 0) {
        availableItemsListMobileButtons.forEach((itemsListMobileButton) => {
          const formElement = itemsListMobileButton.closest('form');

          const disablingClassRemoveCondition = formElement &&
            Number(formElement.dataset.quantityInCart) < Number(formElement.dataset.max) ||
            formElement && !formElement.dataset.quantityInCart && formElement.dataset.isProductAvailable === 'true';

          if (disablingClassRemoveCondition) {
            itemsListMobileButton.classList.remove('disabledButton');
          }
        });
      }
    } else {
      if (cartMenuElement) {
        cartMenuElement.classList.add('disabledInteractivity');
      }
      if (cartMenuCheckoutButtonElement) {
        cartMenuCheckoutButtonElement.classList.add('disabledButton');
      }
      if (availableProductDetailsOrderButton) {
        availableProductDetailsOrderButton.classList.add('disabledButton');
      }
      if (availableItemsListDesktopButtons.length > 0) {
        availableItemsListDesktopButtons.forEach((itemsListDesktopButton) => {
          itemsListDesktopButton.classList.add('disabledButton');
        });
      }
      if (availableItemsListMobileButtons.length > 0) {
        availableItemsListMobileButtons.forEach((itemsListMobileButton) => {
          itemsListMobileButton.classList.add('disabledButton');
        });
      }
    }
  }

  updateCartItemsAlignment() {
    const isCartEmptyCondition = document.getElementById('CartMenuItems').children[0].classList.contains('header__cartMenu-empty');

    if (isCartEmptyCondition) {
      document.getElementById('CartMenuItems').classList.add('justifyContentImportant');
    } else {
      document.getElementById('CartMenuItems').classList.remove('justifyContentImportant');
    }
  }

  updateCartFreeShippingLine() {
    const activeLineElement = document.getElementById('FreeShippingActiveLine');
    const freeShippingMinValue = Number(activeLineElement.dataset.freeShippingMinValue);
    const subtotalPrice = Number(activeLineElement.dataset.subtotalPrice);

    const activeLineWidthPercentage = (subtotalPrice / freeShippingMinValue) * 100;
    const activeLineWidthPercentageResult = activeLineWidthPercentage < 100 ? activeLineWidthPercentage : 100;

    activeLineElement.setAttribute('style', `width: ${activeLineWidthPercentageResult}%;`);
  }

  updateCartItemsQuantityValueOnCartIcon(actualValue) {
    const cartItemsQuantityNumberOnIconElement = document.getElementById('CartButtonQuantity');
    cartItemsQuantityNumberOnIconElement.innerHTML = actualValue;
  }
}

customElements.define('cart-drawer', CartDrawer);

class SyllablesProductQuantityInput extends HTMLElement {
  constructor() {
    super();

    const input = this.querySelector('input[type="number"]');
    const plusButton = this.querySelector('button[name="plus"]');
    const minusButton = this.querySelector('button[name="minus"]');
    const min = parseInt(input.getAttribute('min'), 10);
    const max = parseInt(input.getAttribute('max'), 10);

    plusButton.addEventListener('click', () => {
      if (parseInt(input.value, 10) >= max) {
        return;
      }

      const productDetailsOrderButton = document.querySelector('.productDetails__cartOrderButton[data-is-product-available="true"]');
      const productInventoryQuantity = Number(document.getElementById("ProductDetails").dataset.inventoryQuantity);
      const increasedInputValue = parseInt(input.value, 10) + parseInt(input.step, 10);
      const productDetailsQuantityInCart = Number(document.getElementById('ProductVisualQuantity').dataset.quantityInCart);

      if (
        productDetailsOrderButton &&
        productDetailsQuantityInCart + increasedInputValue > productInventoryQuantity
      ) {
        document.getElementById("ProductDetailsOrderButton").classList.add('disabledButton');
      }

      input.value = increasedInputValue;
    });

    minusButton.addEventListener('click', () => {
      const prevInputValue = input.value;

      if (prevInputValue > 1) {
        const productDetailsOrderButton = document.querySelector('.productDetails__cartOrderButton[data-is-product-available="true"]');
        const productInventoryQuantity = Number(document.getElementById("ProductDetails").dataset.inventoryQuantity);
        const decreasedInputValue = parseInt(input.value, 10) - parseInt(input.step, 10);
        const productDetailsQuantityInCart = Number(document.getElementById('ProductVisualQuantity').dataset.quantityInCart);

        if (
          productDetailsOrderButton &&
          productDetailsQuantityInCart + decreasedInputValue <= productInventoryQuantity
        ) {
          document.getElementById("ProductDetailsOrderButton").classList.remove('disabledButton');
        }

        input.value = Math.max(parseInt(input.value, 10) - parseInt(input.step, 10), min);
      }
    });
  }
}

customElements.define('syllables-product-quantity-input', SyllablesProductQuantityInput);

class SyllablesCartItemQuantityInput extends HTMLElement {
  constructor() {
    super();

    const input = this.querySelector('input[type="number"]');
    const plusButton = this.querySelector('button[name="plus"]');
    const minusButton = this.querySelector('button[name="minus"]');
    const min = parseInt(input.getAttribute('min'), 10);
    const max = parseInt(input.getAttribute('max'), 10);
    const cartLineItemVariantId = input.dataset.variantId;
    const productPageQuantityInput = document.getElementById("ProductVisualQuantity");

    plusButton.addEventListener('click', () => {
      if (parseInt(input.value, 10) === max) {
        return;
      }

      input.value = parseInt(input.value, 10) + parseInt(input.step, 10);
      input.dispatchEvent(new CustomEvent('update-quantity', {
        bubbles: true,
        cancelable: true,
        detail: {
          line: this.querySelector('input[type="number"]').dataset.line,
          quantity: this.querySelector('input[type="number"]').value,
          shouldCartBeOpened: true,
          finallyCallback: () => {
            const productInventoryQuantity = Number(document.getElementById("ProductDetails").dataset.inventoryQuantity);
            const inputValue = Number(input.value);

            if (
              productPageQuantityInput &&
              cartLineItemVariantId === productPageQuantityInput.dataset.variantId &&
              productInventoryQuantity && inputValue >= productInventoryQuantity &&
              document.getElementById("ProductDetailsOrderButton").dataset.isProductAvailable === 'true'
            ) {
              document.getElementById("ProductDetailsOrderButton").classList.add('disabledButton');
              document.getElementById('ProductDetailsInfoMessage').classList.add('displayBlockImportant');
              document.getElementById("ProductDetailsOrderButton").dataset.isProductAbleToCart = 'false';
            }

            if (
              productPageQuantityInput &&
              cartLineItemVariantId === productPageQuantityInput.dataset.variantId
            ) {
              document.getElementById('ProductVisualQuantity').value = 1;
            }
          },
          variantId: cartLineItemVariantId
        }
      }));
    });

    minusButton.addEventListener('click', () => {
      const prevInputValue = input.value;
      input.value = Math.max(parseInt(input.value, 10) - parseInt(input.step, 10), min);

      if (prevInputValue > 1) {
        input.dispatchEvent(new CustomEvent('update-quantity', {
          bubbles: true,
          cancelable: true,
          detail: {
            line: this.querySelector('input[type="number"]').dataset.line,
            quantity: this.querySelector('input[type="number"]').value,
            shouldCartBeOpened: true,
            finallyCallback: () => {
              const productInventoryQuantity = Number(document.getElementById("ProductDetails").dataset.inventoryQuantity);
              const inputValue = Number(input.value);

              if (
                productPageQuantityInput &&
                cartLineItemVariantId === productPageQuantityInput.dataset.variantId &&
                productInventoryQuantity &&
                inputValue >= productInventoryQuantity &&
                document.getElementById("ProductDetailsOrderButton").dataset.isProductAvailable === 'true'
              ) {
                document.getElementById("ProductDetailsOrderButton").classList.remove('disabledButton');
                document.getElementById('ProductDetailsInfoMessage').classList.remove('displayBlockImportant');
                document.getElementById("ProductDetailsOrderButton").dataset.isProductAbleToCart = 'true';
              }

              if (
                productPageQuantityInput &&
                cartLineItemVariantId === productPageQuantityInput.dataset.variantId
              ) {
                document.getElementById('ProductVisualQuantity').value = 1;
              }
            },
            variantId: cartLineItemVariantId
          }
        }));

        if (productPageQuantityInput) {
          document.getElementById('ProductDetailsInfoMessage').classList.remove('displayBlockImportant');
        }
      }
    });
  }
}

customElements.define('syllables-cart-item-quantity-input', SyllablesCartItemQuantityInput);
